module.exports = __webpack_public_path__ + "static/media/folders.c41064a5.svg";